var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99935 0.666687C2.77435 0.666687 0.166016 3.27502 0.166016 6.50002C0.166016 10.875 5.99935 17.3334 5.99935 17.3334C5.99935 17.3334 11.8327 10.875 11.8327 6.50002C11.8327 3.27502 9.22435 0.666687 5.99935 0.666687ZM5.99935 8.58335C4.84935 8.58335 3.91602 7.65002 3.91602 6.50002C3.91602 5.35002 4.84935 4.41669 5.99935 4.41669C7.14935 4.41669 8.08268 5.35002 8.08268 6.50002C8.08268 7.65002 7.14935 8.58335 5.99935 8.58335Z",
    fill: "#72737F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.27383312ba6b4725db36f64643c227bf.svg";
export { ForwardRef as ReactComponent };